export default {
  title: "Linehaul Logs",
  apply_next_status: "Apply next status",
  title_form: "Next status",
  subtitle_form: "Apply the date for the status:",
  text_today: "Today, ",
  button_choose: "Choose a different day",
};
